import React from 'react';
import { Text, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { Grid } from '@mui/material';
import ContentBlock from '../components/ContentBlock.js';
import fyiDoctorsLogoFullLength from '../../../assets/fyi-doctors-full-length.png';
import visiqueLogo from '../../../assets/visque-logo.png';
import bonlookLogo from '../../../assets/bonlook-logo.png';
import solisOpticsLogo from '../../../assets/solis-optics-logo.png';
import raybanLogo from '../../../assets/rayban-logo.png';
import pradaLogo from '../../../assets/prada-logo.png';
import gucciLogo from '../../../assets/gucci-logo.png';
import coachLogo from '../../../assets/coach-logo.png';
import oakleyLogo from '../../../assets/oakley-logo.png';
import { getBrandUrls } from './FYIDoctors.constants.js';

const styles = {
    logo: {
        display: 'block',
        maxWidth: '120px',
        maxHeight: '40px'
    },
    logoSmall: {
        display: 'block',
        maxWidth: '120px',
        maxHeight: '26px'
    },
    logoXSmall: {
        display: 'block',
        maxWidth: '120px',
        maxHeight: '18px'
    },
    contentBlockTop: {
        minHeight: 100,
        alignContent: 'center'
    },
    contentBlockBottom: {
        minHeight: 115,
        alignContent: 'center'
    }
};

/**
 * Brand logos and partners section for FYI Doctors
 */
const FYIDoctorsBrands = () => {
    const brandUrls = getBrandUrls(i18n.locale);

    return (
        <>
            <ContentBlock customStyle={styles.contentBlockTop}>
                <Grid item xs={12} md={5} alignItems="center">
                    <Text
                        large
                        bold
                    >
                        { i18n.t(tokens.labels.perks.fyiDoctorsWhereDiscountsApply) }
                    </Text>
                </Grid>

                <Grid
                    container
                    item
                    xs={12}
                    md={7}
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Grid item xs="auto">
                        <a href={brandUrls.fyiDoctors} target="_blank" rel="noopener noreferrer">
                            <img style={styles.logo} src={fyiDoctorsLogoFullLength} alt="FYI Doctors"/>
                        </a>
                    </Grid>
                    <Grid item xs="auto">
                        <a href={brandUrls.visique} target="_blank" rel="noopener noreferrer">
                            <img style={styles.logo} src={visiqueLogo} alt="Visique" />
                        </a>
                    </Grid>
                    <Grid item xs="auto">
                        <a href={brandUrls.bonlook} target="_blank" rel="noopener noreferrer">
                            <img style={styles.logo} src={bonlookLogo} alt="BonLook"/>
                        </a>
                    </Grid>
                    <Grid item xs="auto">
                        <a href={brandUrls.solisOptics} target="_blank" rel="noopener noreferrer">
                            <img style={styles.logo} src={solisOpticsLogo} alt="Solis Optics"/>
                        </a>
                    </Grid>
                </Grid>
            </ContentBlock>

            <ContentBlock customStyle={styles.contentBlockBottom}>
                <Grid item xs={12} md={5}>
                    <div>
                        <Text
                            large
                            bold
                        >
                            { i18n.t(tokens.labels.perks.fyiDoctorsOver250Brands) }
                        </Text>
                        <Text>
                            { i18n.t(tokens.labels.perks.fyiDoctorsNotAllBrandsAvailable) }
                        </Text>
                    </div>
                </Grid>

                <Grid
                    container
                    item
                    xs={12}
                    md={7}
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Grid item xs="auto">
                        <img src={raybanLogo} style={styles.logoSmall} alt="Ray-Ban"/>
                    </Grid>
                    <Grid item xs="auto">
                        <img src={pradaLogo} style={styles.logoXSmall} alt="Prada"/>
                    </Grid>
                    <Grid item xs="auto">
                        <img src={gucciLogo} style={styles.logoXSmall} alt="Gucci"/>
                    </Grid>
                    <Grid item xs="auto">
                        <img src={coachLogo} style={styles.logoSmall} alt="Coach"/>
                    </Grid>
                    <Grid item xs="auto">
                        <img src={oakleyLogo} style={styles.logoSmall}alt="Oakley"/>
                    </Grid>
                </Grid>
            </ContentBlock>
        </>
    );
};

export default FYIDoctorsBrands;